import type { UserRole } from "@/types/auth/role";

export type TenantConsoleAccountRole = "owner" | "operator";
export type TenantConsoleAccountStatus = "active" | "suspended";

export interface TenantConsoleAccount {
  id: number;
  tenantId: number;
  loginName: string;
  displayName: string;
  role: TenantConsoleAccountRole;
  status: TenantConsoleAccountStatus;
  lastLoginAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface TenantConsoleAccountListData {
  accounts: TenantConsoleAccount[];
  total: number;
  page: number;
  limit: number;
}

export interface TenantUserBinding {
  id: number;
  tenantId: number;
  userId: number;
  username: string;
  phone: string | null;
  role: UserRole | null;
  boundAt: string;
}

export interface TenantUserBindingListData {
  bindings: TenantUserBinding[];
  total: number;
  page: number;
  limit: number;
}

export interface TenantConsoleAccountPasswordResetPayload {
  password: string;
}

export const TENANT_CONSOLE_ACCOUNT_ROLE_LABELS: Record<TenantConsoleAccountRole, string> = {
  owner: "租户所有者",
  operator: "租户运营者",
};

export const TENANT_CONSOLE_ACCOUNT_STATUS_LABELS: Record<TenantConsoleAccountStatus, string> = {
  active: "启用中",
  suspended: "已停用",
};
